import {
    OtherDealsPopupCustomerAction,
    otherDealsPopupModel,
} from "@/core/other-deals-popup/other-deals-popup.model";
import { routerModel } from "@/router/router.model";
import { useI18n } from "@/shared/composables/use-i18n";
import Dialog from "primevue/dialog";
import { Options, setup } from "vue-class-component";
import { Vue } from "vue-property-decorator";
import {
    GetAuthenticatedVehiclesQueryParams,
    VehicleLabel,
} from "@/shared/api-contract/api-contract";
import format from "date-fns/format";
import VehicleGroupCardComponent from "@/shared/components/app-vehicle-group-card/app-vehicle-group-card.vue";
import { AppRangeSliderModel } from "@/shared/components/app-range-slider/app-range-slider-model";

@Options({
    components: {
        Dialog,
        VehicleGroupTile: VehicleGroupCardComponent,
    },
})
export class OtherDealsPopup extends Vue {
    i18n = setup(useI18n);
    model = setup(() => otherDealsPopupModel);

    markClass: Record<VehicleLabel, string> = {
        [VehicleLabel.newIn]: "new-in",
        [VehicleLabel.specialDeal]: "special-deal",
        [VehicleLabel.reducedPrice]: "reduced-price",
    };
    markTitle: Record<VehicleLabel, string> = {
        [VehicleLabel.newIn]: "NEW IN!",
        [VehicleLabel.specialDeal]: "SPECIAL DEAL!",
        [VehicleLabel.reducedPrice]: "REDUCED PRICE!",
    };

    conditionFilterModel = [] as readonly number[];
    gearboxFilterModel = [] as readonly number[];
    bodyworkFilterModel = [] as readonly number[];
    bodytypeFilterModel = [] as readonly number[];
    fueltypeFilterModel = [] as readonly number[];
    brandFilterModel = [] as readonly number[];
    modelFilterModel = [] as readonly string[];
    availabilityFilterModel = [] as readonly number[];
    providerFilterModel = [] as readonly number[];
    colorFilterModel = [] as readonly number[];
    emissionWltpFilterModel: AppRangeSliderModel = {
        from: null,
        to: null,
    };
    emissionNedcFilterModel: AppRangeSliderModel = {
        from: null,
        to: null,
    };
    mileageFilterModel: AppRangeSliderModel = {
        from: null,
        to: null,
    };
    damageFilterModel: AppRangeSliderModel = {
        from: null,
        to: null,
    };

    priceFilterModel: AppRangeSliderModel = {
        from: null,
        to: null,
    };
    firstregistrationYearFilterModel: AppRangeSliderModel = {
        from: null,
        to: null,
    };
    hasPromotionFilterModel = null;

    get isOnlyNewTypeSelected() {
        return (
            this.conditionFilterModel.length === 1 && this.conditionFilterModel[0] === 2
        ); // 2 = ID of "New"
    }

    get getVehicleFilterQueryParameters(): GetAuthenticatedVehiclesQueryParams {
        return {
            condition: this.conditionFilterModel,
            brand: this.brandFilterModel,
            model: this.modelFilterModel,
            fueltype: this.fueltypeFilterModel,
            color: this.colorFilterModel,
            gearbox: this.gearboxFilterModel,
            promotion: [], // TODO: allow filtering on promotions!
            option: [], // TODO: allow filtering on options!
            bodywork: this.bodyworkFilterModel,
            bodytype: this.bodytypeFilterModel,
            availability: this.availabilityFilterModel,
            provider: this.providerFilterModel,
            emission_nedc_min: this.emissionNedcFilterModel.from,
            emission_nedc_max: this.emissionNedcFilterModel.to,
            emission_wltp_min: this.emissionWltpFilterModel.from,
            emission_wltp_max: this.emissionWltpFilterModel.to,
            mileage_min: this.isOnlyNewTypeSelected ? null : this.mileageFilterModel.from,
            mileage_max: this.isOnlyNewTypeSelected ? null : this.mileageFilterModel.to,
            damage_amount_min: this.damageFilterModel.from,
            damage_amount_max: this.damageFilterModel.to,
            price_min: this.priceFilterModel.from,
            price_max: this.priceFilterModel.to,
            firstregistration_year_min: this.firstregistrationYearFilterModel.from,
            firstregistration_year_max: this.firstregistrationYearFilterModel.to,
            has_promotion: this.hasPromotionFilterModel,
        };
    }

    formatDate(_date: bigint | null): string {
        if (!_date) return "";
        return `/ ${format(new Date(_date.toString()), "yyyy")}`;
    }

    close() {
        this.model.show = false;
    }

    get query() {
        return routerModel.router.currentRoute.value.query;
    }

    get message() {
        if (this.model.customerAction === OtherDealsPopupCustomerAction.like) {
            return this.i18n.t("otherDealsPopup.messageLIKE");
        } else {
            return this.i18n.t("otherDealsPopup.messageBUY");
        }
    }

    get viewButtonText() {
        if (this.model.customerAction === OtherDealsPopupCustomerAction.like) {
            return this.i18n.t("otherDealsPopup.buttonLIKE");
        } else {
            return this.i18n.t("otherDealsPopup.buttonBUY");
        }
    }

    get viewLink() {
        if (this.model.customerAction === OtherDealsPopupCustomerAction.like) {
            return "/auth/my-carconnex/my-favorites";
        } else {
            return "/shopping-cart";
        }
    }
}
